import { createRouter, createWebHistory } from 'vue-router'
const Dashboard = () => import('@/components/dashboard/dashboard')
const Login = () => import('@/components/login/login.vue')
const TransactionTrace = () => import('@/components/transactiontrace/transactiontrace')
// const testingSolution = () => import('@/components/testingSolution/testingSolution')
const Payments = () => import('@/components/payments/payments')
const Purchase = () => import('@/components/purchase/purchase')
const OrderSummary = () => import('@/components/ordersummary/ordersummary')
const BusinessAttributes = () => import('@/components/businessAttributes/addAttributes/businessAttributes.vue')
const ManageMerchant = () => import('@/components/manageMerchant/manageMerchant')
const AddMerchant = () => import('@/components/manageMerchant/addMerchant/addMerchant')
const UpdateMerchant = () => import('@/components/manageMerchant/updateMerchant/updateMerchant')
const ManagePOS = () => import('@/components/managePOS/managePOS')
const AddPOS = () => import('@/components/managePOS/addPOS/addPOS')
const UpdatePOS = () => import('@/components/managePOS/updatePOS/updatePOS')
const ManageGateways = () => import('@/components/manageGateways/manageGateways')
const AddGateways = () => import('@/components/manageGateways/addGateways/addGateways')
const UpdateGateways = () => import('@/components/manageGateways/updateGateways/updateGateways')
const PgMerchant = () => import('@/components/manageGateways/pgMerchant/pgMerchant')
const AddCredential = () => import('@/components/manageGateways/pgMerchant/addCredential/addCredential')
const UpdateCredential = () => import('@/components/manageGateways/pgMerchant/updateCredential/updateCredential')
const addRolePermission = () => import('@/components/role/addRole.vue')
const permission = () => import('@/components/role/permission/permission.vue')
const manageUser = () => import('@/components/manageUser/manageUser.vue')
const userMerchantConfiguration = () => import('@/components/manageUser/userMerchantConfig/userMerchantConfig.vue')
const ManageCustomers = () => import('@/components/manageCustomers/manageCustomers')
const AddCustomers = () => import('@/components/manageCustomers/addCustomers/addCustomers')
const UpdateCustomers = () => import('@/components/manageCustomers/updateCustomers/updateCustomers')
const MerchantApiKey = () => import('@/components/manageUser/merchantApikey/MerchantApiKey.vue');
const ManageBusinessAttributes = () => import('@/components/businessAttributes/manageBusinessAttributes.vue');
const UpdateBusinessAttributes = () => import('@/components/businessAttributes/updateAttributes/updateBusinessAttributes.vue')
const ManageMerchantGateway = () => import('@/components/merchantGateways/manageMerchantGateway.vue')
const AddMerchantGateway = () => import('@/components/merchantGateways/add/merchantGateway.vue')
const UpdateMerchantGateway = () => import('@/components/merchantGateways/update/merchantGateway.vue')
const AddRoutingRules = () => import('@/components/routingRules/add/routingRules.vue');
const UpdateRoutingRules = () => import('@/components/routingRules/update/routingRules.vue');
const ManageRoutingRules = () => import('@/components/routingRules/manageRoutingRules.vue');
const AddRoutingTemplate = () => import('@/components/routingTemplate/add/routingTemplate.vue');
const UpdateRoutingTemplate = () => import('@/components/routingTemplate/update/routingTemplate.vue');
const ManageRoutingTemplate = () => import('@/components/routingTemplate/manageRoutingTemplate.vue');
const OrderTransactions = () => import('@/components/orderTransactions/orderTransaction.vue');
const RefundTransactions = () => import('@/components/refundTransaction/refundTransaction.vue');
const VirtualCards = () => import('@/components/virtualCard/virtualCard.vue');
const ManageVirtualCards = () => import('@/components/virtualCard/manageVirtualCard.vue');
const routes = [
	{
		path: '/',
		redirect: '/login',
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		meta: {}
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {}
	},
	{
		path: '/transactiontrace',
		name: 'TransactionTrace',
		component: TransactionTrace,
		meta: {}
	},
	{
		path: '/payments',
		name: 'Payments',
		component: Payments,
		meta: {}
	},
	{
		path: '/purchase',
		name: 'Purchase',
		component: Purchase,
		meta: {}
	},
	{
		path: '/businessAttributes',
		name: 'BusinessAttributes',
		component: BusinessAttributes,
		meta: {}
	},
	{
		path: '/ordersummary',
		name: 'OrderSummary',
		component: OrderSummary,
		meta: {}
	},
	{
		path: '/manageMerchant',
		name: 'ManageMerchant',
		component: ManageMerchant,
		meta: {}
	},
	{
		path: '/manageMerchant/addMerchant',
		name: 'AddMerchant',
		component: AddMerchant,
		meta: {}
	},
	{
		path: '/manageMerchant/updateMerchant',
		name: 'UpdateMerchant',
		component: UpdateMerchant,
		meta: {}
	},
	{
		path: '/managePOS',
		name: 'ManagePOS',
		component: ManagePOS,
		meta: {}
	},
	{
		path: '/managePOS/addPOS',
		name: 'AddPOS',
		component: AddPOS,
		meta: {}
	},
	{
		path: '/managePOS/updatePOS',
		name: 'UpdatePOS',
		component: UpdatePOS,
		meta: {}
	},
	{
		path: '/manageCustomers',
		name: 'ManageCustomers',
		component: ManageCustomers,
		meta: {}
	},
	{
		path: '/manageCustomers/addCustomers',
		name: 'AddCustomers',
		component: AddCustomers,
		meta: {}
	},
	{
		path: '/manageCustomers/updateCustomers',
		name: 'UpdateCustomers',
		component: UpdateCustomers,
		meta: {}
	},
	{
		path: '/manageGateways',
		name: 'manageGateways',
		component: ManageGateways,
		meta: {}
	},
	{
		path: '/manageGateways/addGateways',
		name: 'AddGateways',
		component: AddGateways,
		meta: {}
	},
	{
		path: '/manageGateways/updateGateways',
		name: 'UpdateGateways',
		component: UpdateGateways,
		meta: {}
	},
	{
		path: '/manageGateways/pgMerchant',
		name: 'PgMerchant',
		component: PgMerchant,
		meta: {}
	},
	{
		path: '/manageGateways/pgMerchant/addCredential',
		name: 'AddCredential',
		component: AddCredential,
		meta: {}
	},
	
	{
		path: '/manageGateways/pgMerchant/updateCredential',
		name: 'UpdateCredential',
		component: UpdateCredential,
		meta: {}
	},
	{
		path: '/addRolePermission',
		name: 'addRolePermission',
		component: addRolePermission,
		meta: {}
	},
	{
		path: '/rolePermissions',
		name: 'rolePermissions',
		component: permission,
		meta: {}
	},
	{
		path: '/manageUser',
		name: 'manageUser',
		component: manageUser,
		meta: {}
	},
	{
		path: '/userMerchantConfiguration',
		name: 'userMerchantConfiguration',
		component: userMerchantConfiguration,
		meta: {}
	},
	{
		path: '/merchantApiKey',
		name: 'MerchantApiKey',
		component: MerchantApiKey,
		meta: {}
	},
	{
		path: '/manageBusinessAttributes',
		name: 'manageBusinessAttributes',
		component: ManageBusinessAttributes,
		meta: {}
	},
	{
		path: '/updateBusinessAttributes',
		name: 'updateBusinessAttributes',
		component: UpdateBusinessAttributes,
		meta: {}
	},
	{
		path: '/manageMerchantGateways',
		name: 'manageMerchantGateway',
		component: ManageMerchantGateway,
		meta: {}
	},
	{
		path: '/addMerchantGateway',
		name: 'addMerchantGateway',
		component: AddMerchantGateway,
		meta: {}
	},
	{
		path: '/updateMerchantGateway',
		name: 'updateMerchantGateway',
		component: UpdateMerchantGateway,
		meta: {}
	},
	{
		path: '/addRoutingRules',
		name: 'addRoutingRules',
		component: AddRoutingRules,
		meta: {}
	},
	{
		path: '/updateRoutingRules',
		name: 'updateRoutingRules',
		component: UpdateRoutingRules,
		meta: {}
	},
	{
		path: '/manageRoutingRules',
		name: 'manageRoutingRules',
		component: ManageRoutingRules,
		meta: {}
	},
	{
		path: '/manageRoutingTemplate',
		name: 'manageRoutingTemplate',
		component: ManageRoutingTemplate,
		meta: {}
	},
	{
		path: '/addRoutingTemplate',
		name: 'addRoutingTemplate',
		component: AddRoutingTemplate,
		meta: {}
	},
	{
		path: '/updateRoutingTemplate',
		name: 'updateRoutingTemplate',
		component: UpdateRoutingTemplate,
		meta: {}
	},
	{
		path: '/orderTransactions',
		name: 'orderTransactions',
		component: OrderTransactions,
		meta: {}
	},
	{
		path: '/refundTransactions',
		name: 'refundTransactions',
		component: RefundTransactions,
		meta: {}
	},
	{
		path: '/virtualCards',
		name: 'virtualCards',
		component: VirtualCards,
		meta: {}
	},
	{
		path: '/manageVirtualCards',
		name: 'manageVirtualCards',
		component: ManageVirtualCards,
		meta: {}
	}
	
]

const router = createRouter({
history: createWebHistory(process.env.BASE_URL),
routes
})

export default router
